import { defineMessages } from 'react-intl';

export default defineMessages({
  pageTitle: 'Governance',

  title: 'Proposal Details',
  download: 'Download',
  shareOnTwitter: 'Share on Twitter',

  leaderboard: 'Leaderboard - {details}',

  proposal: 'Proposal',
  details: 'Details',
});
